import React from "react";
import CompanyLogo from "../../../../../Images/CompanyLogo.avif";
import CompanyProfileCounters from "../CompanyProfileCounters/CompanyProfileCounters";

export default function CompanyProfileData({ company }) {
  return (
    <>
      <div className="card CompanyProfileData">
        <div className="card-header">
          <div className="logoCompany text-center">
            <img src={CompanyLogo} alt="" />
          </div>
        </div>
        <div className="card-body">
          <CompanyProfileCounters company={company} />
          <div className="text-center">
            <h4>{company?.name}</h4>
            {/* <p className="text-100"> أحمد محمد العمري</p> */}
            <p className="mb-0"> {company?.city} </p>
            <p className="mb-0">{company?.address}</p>
          </div>
        </div>
      </div>
    </>
  );
}
